<template>
    <v-tab-item :value="ABOUT.value">
        <div class="page-section-wrap">
            <section class="page-section">
                <div>
                    <v-row>
                        <v-col cols="12" lg="6">
                            <h2 class="tit">프라이빗 세일(Private Sales)이란?</h2>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <div class="page-text word-keep-all">
                                <p>우리는 일반적으로 공개 경매의 경쟁 설정을 권장하지만 경우에 따라 비공개 매매 (프라이빗 세일)가 더 적절합니다. 일부 개체의 경우 특히 적절한 구매자(박물관 또는 특히 동기가 부여된 수집가)가 한 명 있을 수 있습니다. 때때로 판매자의 상황은 판매를 위한 짧은 시간 프레임 또는 개인 판매의 재량을 요구할 수도 있습니다.</p>
                                <p class="mt-10 mt-md-14">시장과 그 시장을 주도하는 수집가, 기관 및 딜러에 대한 우리의 지식을 통해 우리는 적절한 구매자에게 훌륭한 물건을 매칭할 수 있습니다. 개인 판매(일반적으로 $50,000 이상 가치)에는 더 중요한 물건만 고려됩니다. 개인 판매에 대한 우리의 수수료는 작품의 가치와 성격에 따라 다릅니다.</p>
                            </div>
                            <v-divider class="my-20 my-md-24"></v-divider>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <p class="page-text primary--text">개인적으로 판매하고 싶은 중요한 품목이 있는 경우, <br class="d-none d-md-block" />측면 버튼을 클릭하여 저희에게 연락하십시오.</p>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-btn large block color="primary" to="/form/consignment-sale">문의하기</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
                <div class="mt-30 mt-lg-50">
                    <v-img cover class="img-wide" src="/images/sub/private/private-define-img.png"></v-img>
                </div>
            </section>

            <section class="page-section">
                <div class="mb-20 mb-md-30">
                    <v-row>
                        <v-col cols="12" lg="6">
                            <h2 class="tit">Private Sales</h2>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <h3 class="tit tit--sm line-height-14">당사는 공개 경쟁을 통한 경매를 권장하지만, <br class="d-none d-md-block" />경우에 따라 비공개 매매(프라이빗 세일)가 더 적절합니다</h3>
                        </v-col>
                    </v-row>
                </div>
                <div class="my-n14 my-md-n20">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <div class="py-4 py-md-6">
                                <div class="gallery-card">
                                    <div class="gallery-card__img-wrap">
                                        <v-img :aspect-ratio="585 / 300" src="/images/sub/private/private-define-img2.png" class="grey-ef" />
                                    </div>
                                    <div class="gallery-card__con py-20 pt-lg-20 pb-lg-30">
                                        <div class="mb-10">
                                            <h4 class="tit tit--xs">비공개 매매</h4>
                                        </div>
                                        <div>
                                            <p class="page-text">프라이빗 세일은 특정작품 혹은 특별한 작품을, 경매를 통하지 않고, <br class="d-none d-md-block" />비공개적 방법으로 매매합니다.</p>
                                        </div>
                                    </div>
                                    <v-divider class="primary"></v-divider>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <div class="py-4 py-md-6">
                                <div class="gallery-card">
                                    <div class="gallery-card__img-wrap">
                                        <v-img :aspect-ratio="585 / 300" src="/images/sub/private/private-define-img3.png" class="grey-ef" />
                                    </div>
                                    <div class="gallery-card__con py-20 pt-lg-20 pb-lg-30">
                                        <div class="mb-10">
                                            <h4 class="tit tit--xs">높은 보안성</h4>
                                        </div>
                                        <div>
                                            <p class="page-text">고정된 가격과 편안한 일정으로 매매하며, <br class="d-none d-md-block" />보안성이 매우 높은 거래방식입니다.</p>
                                        </div>
                                    </div>
                                    <v-divider class="primary"></v-divider>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <div class="py-4 py-md-6">
                                <div class="gallery-card">
                                    <div class="gallery-card__img-wrap">
                                        <v-img :aspect-ratio="585 / 300" src="/images/sub/private/private-define-img4.png" class="grey-ef" />
                                    </div>
                                    <div class="gallery-card__con py-20 pt-lg-20 pb-lg-30">
                                        <div class="mb-10">
                                            <h4 class="tit tit--xs">매개를 통한 1 : 1 거래방식</h4>
                                        </div>
                                        <div>
                                            <p class="page-text">당사를 매개로 개인과 개인간에 이루어지는 사적(私的)인 거래방식이며, <br class="d-none d-md-block" />특별하고 독특한 예술 작품을, 신중하고 내밀(內密)하게 매매할 수 있는 방식입니다.</p>
                                        </div>
                                    </div>
                                    <v-divider class="primary"></v-divider>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <div class="py-4 py-md-6">
                                <div class="gallery-card">
                                    <div class="gallery-card__img-wrap">
                                        <v-img :aspect-ratio="585 / 300" src="/images/sub/private/private-define-img5.png" class="grey-ef" />
                                    </div>
                                    <div class="gallery-card__con py-20 pt-lg-20 pb-lg-30">
                                        <div class="mb-10">
                                            <h4 class="tit tit--xs">판매자 구매자 모두를 만족</h4>
                                        </div>
                                        <div>
                                            <p class="page-text">위탁 고객의 요구사항, 가격, 일정 등을 존중하며, 개별화된 접근방식으로 <br class="d-none d-md-block" />잠재구매자와 접촉하여, 쌍방 고객에게 최상의 대안을 제시합니다.</p>
                                        </div>
                                    </div>
                                    <v-divider class="primary"></v-divider>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>

            <section class="page-section">
                <div class="mb-20 mb-md-40">
                    <h2 class="tit">참여 방법</h2>
                </div>
                <div class="my-n10 my-md-0">
                    <v-row no-gutters>
                        <v-col cols="6" md="4">
                            <div class="py-10 py-md-0">
                                <div class="mb-14 mb-md-24">
                                    <v-img contain width="56" height="56" src="/images/sub/private/private-define-icon.png"></v-img>
                                </div>
                                <div>
                                    <h5 class="tit tit--xs font-weight-regular">작품정보 확인</h5>
                                    <v-divider class="primary v-divider--dot my-16"></v-divider>
                                    <p class="page-text">우선, 작가명, 작품명, 연도, 크기, 재질 등의 <br class="d-none d-md-block" />작품정보를 확인합니다.</p>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="6" md="4">
                            <div class="py-10 py-md-0">
                                <div class="mb-14 mb-md-24">
                                    <v-img contain width="56" height="56" src="/images/sub/private/private-define-icon2.png"></v-img>
                                </div>
                                <div>
                                    <h5 class="tit tit--xs font-weight-regular">참고자료 전달</h5>
                                    <v-divider class="primary v-divider--dot my-16"></v-divider>
                                    <p class="page-text">기타 작품과 관련된 사진 및 참고자료가 있으면 <br class="d-none d-md-block" />제공해 주십시요.</p>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="6" md="4">
                            <div class="py-10 py-md-0">
                                <div class="mb-14 mb-md-24">
                                    <v-img contain width="64" height="56" src="/images/sub/private/private-define-icon3.png"></v-img>
                                </div>
                                <div>
                                    <h5 class="tit tit--xs font-weight-regular">KICI 연락</h5>
                                    <v-divider class="primary v-divider--dot my-16"></v-divider>
                                    <p class="page-text">당사로 전화 혹은 이메일로 연락을 주십시오 <br class="d-none d-md-block" />문의사항에 대하여 친절하고 상세하게 안내해 드리겠습니다.</p>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>
        </div>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_TABS } from "@/assets/variables";
const { ABOUT } = PRIVATE_SALES_TABS;
export default {
    data() {
        return {
            ABOUT,
        };
    },
};
</script>

<style></style>
